import { render, staticRenderFns } from "./ProductsBlock.vue?vue&type=template&id=71851d33&scoped=true&"
import script from "./ProductsBlock.vue?vue&type=script&lang=js&"
export * from "./ProductsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProductsBlock.vue?vue&type=style&index=0&id=71851d33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71851d33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
